module.exports = __webpack_public_path__ + "img/university-header.694f2174.png";